/* eslint-disable vue/one-component-per-file */
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import VeeValidate from "vee-validate";
import vSelect from "vue-select";
import VModal from "vue-js-modal";
import DatePicker from "@/user/components/DatePicker.vue"

export default function() {
  const { $ } = window;
  const reportsPage = $("#reports-page");

  if (reportsPage.length < 1) {
    return;
  }

  Vue.use(VueLazyload);
  Vue.use(VeeValidate);
  Vue.use(VModal, { dynamic: true, dialog: true, injectModalsContainer: true });
  Vue.component("v-select", vSelect);
  Vue.component("date-picker", DatePicker);

  const url = new URL(window.location.href);
  const params = url.searchParams;

  const startDate = params.get("start_date");
  const endDate = params.get("end_date");
  const startOfCreatedDate = params.get("start_of_created_date");
  const endOfCreatedDate = params.get("end_of_created_date");
  const dateOption = params.get("date_option");
  const outletName = params.get("restaurant_name_like");

  const app = new Vue({
    el: "#reports-page",
    data: {
      outletName: outletName || "",
      startDate: startDate || startOfCreatedDate || "",
      endDate: endDate || endOfCreatedDate || "",
      dateOption: dateOption || "created_date",
    },
    mounted() {
      // check if there is no query string, then reload with default query string
      // ?date_option=dining_date&start_date={beginning of month}&end_date={end of month}
      if (!url.search) {
        // Set the initial date to a UTC date
        const date = new Date(new Date().toLocaleString("en-US", { timeZone: "UTC" }));

        // Get the first day of the month
        date.setDate(1);
        const formattedFirstDayOfMonth = date.toISOString().slice(0, 10);

        // Get the last day of the month
        date.setMonth(date.getMonth() + 1);
        date.setDate(0);
        const formattedLastDayOfMonth = date.toISOString().slice(0, 10);

        params.set("date_option", "dining_date");
        params.set("start_date", formattedFirstDayOfMonth);
        params.set("end_date", formattedLastDayOfMonth);

        url.search = params.toString();
        window.location.href = url.toString();
      }
    },
    methods: {
      setOrDeleteParam(paramName, value) {
        if (value) {
          params.set(paramName, value);
        } else {
          params.delete(paramName);
        }
      },
      async search(scope) {
        const isFormValid = await this.$validator.validateAll(scope);
        if (!isFormValid) {
          alert("Please input valid data");
          return;
        }

        this.setOrDeleteParam("restaurant_name_like", this.outletName);
        this.setOrDeleteParam("date_option", this.dateOption);

        if (this.dateOption === "dining_date") {
          this.setOrDeleteParam("start_date", this.startDate);
          this.setOrDeleteParam("end_date", this.endDate);
          params.delete("start_of_created_date");
          params.delete("end_of_created_date");
        }

        if (this.dateOption === "created_date") {
          this.setOrDeleteParam("start_of_created_date", this.startDate);
          this.setOrDeleteParam("end_of_created_date", this.endDate);
          params.delete("start_date");
          params.delete("end_date");
        }
        params.delete("page");

        url.search = params.toString();
        window.location.href = url.toString();
      },
      clearForm() {
        this.outletName = "";
        this.startDate = "";
        this.endDate = "";
        this.dateOption = "created_date";
        this.search();
      },
    },
  });

  return app;
}
